import gql from "graphql-tag";
import PinnableCommentFields from "../../fragments/PinnableCommentFields";

export default gql`
  mutation PinAssetDiscussionComment($commentId: ObjectID!) {
    pinAssetDiscussionComment(commentId: $commentId) {
      _id
      ...PinnableCommentFields
    }
  }

  ${PinnableCommentFields}
`;
